import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { COLORS } from '../../theme';

function isBodyVariant(variant?: string) {
  return variant?.includes('body');
}

export default styled(Typography)((props) => ({
  whiteSpace: 'pre-line',
  color: isBodyVariant(props.variant) ? COLORS.gray[1200] : COLORS.brand.night,
}));
